import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const deleteFormInstance = async (id: number) => {
	const url = `/observations/instances/${id}/`;

	const response = await cmsClient.delete<IFormInstance>(url);
	return response.data;
};

const useDeleteObservationFormInstance = () => {
	const mutation = useMutation(deleteFormInstance);

	return mutation;
};

export default useDeleteObservationFormInstance;
